import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import SaveIcon from '@mui/icons-material/Save';
import { useLayoutPreferences } from '../../../../context/LayoutPreferencesContext';

interface DiscardChangesDialogProps {
  open: boolean;
  onClose: () => void;
  onSaveDraft: () => void;
  onDiscard: () => void;
  savingDraft: boolean;
}

function DiscardChangesDialog({ open, onClose, onSaveDraft, onDiscard, savingDraft }: DiscardChangesDialogProps) {
  const { sidebarColor } = useLayoutPreferences();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: 2 } }}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1.5, pb: 1 }}>
        <WarningAmberIcon sx={{ color: '#fd7e14' }} />
        <Typography variant="subtitle1" fontWeight={700}>
          Données non sauvegardées
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ fontSize: '0.9rem', color: 'text.primary' }}>
          Des données saisies n'ont pas encore été enregistrées. Que souhaitez-vous faire ?
        </DialogContentText>
      </DialogContent>
      <DialogActions disableSpacing sx={{ px: 3, pb: 2.5, pt: 0, rowGap: 1, flexDirection: 'column', alignItems: 'stretch' }}>
        <Button
          fullWidth
          variant="contained"
          startIcon={savingDraft ? <CircularProgress size={14} color="inherit" /> : <SaveIcon />}
          onClick={onSaveDraft}
          disabled={savingDraft}
          sx={{ textTransform: 'none', fontWeight: 600, backgroundColor: sidebarColor, '&:hover': { backgroundColor: sidebarColor, opacity: 0.9 } }}
        >
          Enregistrer le brouillon
        </Button>
        <Button
          fullWidth
          variant="outlined"
          onClick={onDiscard}
          sx={{ textTransform: 'none', fontWeight: 500, color: '#dc3545', borderColor: '#dc3545', '&:hover': { backgroundColor: '#dc354510', borderColor: '#dc3545' } }}
        >
          Abandonner les données saisies
        </Button>
        <Button
          fullWidth
          variant="outlined"
          onClick={onClose}
          sx={{ textTransform: 'none', color: '#6c757d', borderColor: '#6c757d', '&:hover': { borderColor: '#6c757d', backgroundColor: '#6c757d10' } }}
        >
          Annuler
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DiscardChangesDialog;
